import './AboutUsStyles.css'

function AboutUs(){
    return(
        <>
        <h1>Our Mission</h1>
        <p>
        "At Stickerine, we believe in the power of self-expression and individuality. Our mission is to empower every person to create and purchase their own unique stickers online, fostering creativity and personal connection. By providing a seamless platform, we enable individuals to turn their ideas into tangible expressions, adding joy and personality to everyday objects. We are dedicated to delivering high-quality, customizable stickers that reflect the diverse passions, interests, and stories of our customers."
        </p>

        <h2>
        Vision Statement
        </h2>
        <p>
        Our vision at Stickerine is to revolutionize the way people personalize and adorn their belongings. We envision a world where every laptop, water bottle, notebook, and more is adorned with custom stickers that reflect the essence of its owner. Through innovative technology and a commitment to customer satisfaction, we aim to become the go-to destination for individuals seeking to amplify their self-expression and leave a lasting mark on the world, one sticker at a time.   
        </p>
        </>
    )
}

export default AboutUs